import Div from "@jumbo/shared/Div/Div";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import {useEffect, useState} from "react";
import {MultiSelect} from "react-multi-select-component";

const SendForSignature = ({isModalOpen, handleModalClose, items, onSubmit}) => {
    const [selectedItems, setSelectedItems] = useState([]);

    useEffect(() => {
        // To reset the data once the modal is closed
        if (isModalOpen) {
            setSelectedItems([]);
        }
    }, [isModalOpen]);

    return (
        <Modal open={isModalOpen} onClose={handleModalClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
            <Div className="customize-modal">
                <div className="modal-head">
                    <h2>Send for Signature</h2>
                    <IconButton className="close-modal-btn p-0" onClick={handleModalClose}>
                        <HighlightOffIcon/>
                    </IconButton>
                </div>
                <Div sx={{minHeight: "35vh"}} className="modal-body-content">
                    <MultiSelect options={items} value={selectedItems} onChange={setSelectedItems} onMenuToggle={() => {
                    }}/>
                </Div>
                <div className="modal-foot">
                    <Button
                        type="button"
                        className="btn-theme px-5 ms-auto d-block"
                        onClick={() => {
                            onSubmit(selectedItems);
                            handleModalClose();
                        }}
                        disabled={!selectedItems || selectedItems.length === 0}
                    >
                        Send for Signature
                    </Button>
                </div>
            </Div>
        </Modal>
    );
};

export default SendForSignature;